<template>
  <div class="changelog item">
    <div>
      <div v-for="(lval, lkey) in log" :key="lkey">
        <span class="user">{{ user_name(lval.user_id) }} - {{ time(lval.created_at) }}</span>
        <table>
          <tr v-for="(dval, dkey) in lval.data" :key="dkey">
            <td style="width: 140px">{{ dkey }}: </td>
            <td>{{ dval }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
export default {
  props: ['model', 'id'],
  data() {
    return {
      users: [],
      log: [],
    }
  },
  methods: {
    time(created) {
      const date = dayjs.utc(created);
      return date.local().format(this._.date_format_comments);
    },
    user_name(id) {
      let match = this.users.find(user => user.id === id);
      return (match) 
        ? match.first_name + ' ' + match.last_name
        : 'System';
    },
  },
  async created() {
    dayjs.extend(utc);
    const log = await this.axios.get(API_URL + '/logs', {
      params: {
        model: this.model,
        id: this.id,
      }
    });
    this.setProgress(false);
    this.users = log.data.users;
    this.log = log.data.log;
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.changelog.item {
  position: absolute;
  top: 0;
  right: 0;
  width: 680px;
  height: 100%;
  opacity: .95;
  > div {
    background: #ffffff;
    border-left: 1px solid lighten($primary-color, 80%);
    position: sticky;
    top: 0;
    height: calc(100vh - 178px);
    overflow-y: scroll;
    > div {
      padding: 12px;
      &:not(:first-child) {
        border-top: 1px solid lighten($primary-color, 80%);
      }
      > span {
        display: inline-block;
        opacity: .4;
        padding-left: 2px;
        margin-bottom: 3px;
        border-bottom: 0;
      }
    }
  }
}
</style>